import styled from 'styled-components';

export const Container = styled.div``;

export const List = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;

  list-style: none;
`;

export const ListItem = styled.li<{ $totalAmount: number }>`
  box-sizing: border-box;
  width: ${({ $totalAmount }) => `calc(100% / ${$totalAmount})`};
  border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  &:last-child {
    border-right: none;
  }
`;
